import { render, staticRenderFns } from "./MerchantUpload.vue?vue&type=template&id=0f986ecb"
import script from "./MerchantUpload.vue?vue&type=script&lang=js"
export * from "./MerchantUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports